export default "__VITE_ASSET__BxfvneMA__"